import { Building2, MapPin, Trophy } from "lucide-react";
import MotionSection from "../common/MotionSection";
import SectionHeading from "../common/SectionHeading";

function CountryUniversitiesSection({ country }) {
  return (
    <MotionSection className="py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-6">
        <SectionHeading
          kicker="Top Universities"
          title={`Leading Institutions in ${country.name}`}
          description="A curated showcase of universities often preferred by students based on quality, reputation, and outcomes."
        />

        <div className="relative mt-10 overflow-hidden rounded-[2rem] border border-midnight-navy/10 bg-white/70 p-4 shadow-soft md:p-6">
          <div className="absolute -right-24 top-0 h-56 w-56 rounded-full bg-royal-blue/12 blur-3xl" />
          <div className="absolute -left-16 bottom-0 h-44 w-44 rounded-full bg-warm-gold/14 blur-3xl" />

          <div className="relative grid gap-4 md:grid-cols-2 xl:grid-cols-3">
            {country.universities.map((uni, index) => (
              <article
                key={uni.name}
                className="group signature-card signature-card-interactive rounded-2xl p-5"
              >
                <div className="flex items-center justify-between gap-3">
                  <span className="inline-flex items-center gap-1.5 rounded-full bg-midnight-navy px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.08em] text-sky-glow">
                    <Trophy className="h-3.5 w-3.5 text-warm-gold" aria-hidden="true" />
                    Top {index + 1}
                  </span>
                  <span className="inline-flex items-center gap-1 text-xs font-medium text-slate-text/75">
                    <MapPin className="h-3.5 w-3.5 text-royal-blue" aria-hidden="true" />
                    {uni.city}
                  </span>
                </div>

                <h3 className="mt-4 text-xl leading-snug text-midnight-navy">{uni.name}</h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-text/82">{uni.text}</p>

                <div className="mt-5 flex flex-wrap gap-2">
                  <span className="rounded-full border border-midnight-navy/12 bg-sky-glow/75 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.08em] text-midnight-navy">
                    Academic Reputation
                  </span>
                  <span className="rounded-full border border-midnight-navy/12 bg-sky-glow/75 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.08em] text-midnight-navy">
                    Strong Outcomes
                  </span>
                </div>

                <div className="mt-5 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.1em] text-royal-blue">
                  <Building2 className="h-3.5 w-3.5" aria-hidden="true" />
                  Recommended by NextEra
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </MotionSection>
  );
}

export default CountryUniversitiesSection;
